import { css, cx } from '@linaria/core'
import type { CSSProperties, FC, ReactNode } from 'react'
import type { ItemGridContentProps } from '#features/VirtualizedGrid'
import type { ComparisonDataEntry } from '#pages/Configuration/Comparison/useLinearizeComparisonData'
import type { ChangeTableContext } from '../useChangesTable'
import { ChangeFamilyRow } from './ChangeFamilyRow'
import { ChangeGroupRow } from './ChangeGroupRow'
import { ChangeSubGroupRow } from './ChangeSubGroupRow'

const memoizerClass = css`
  display: grid;
  grid-column: 1 / 13;
  grid-template-columns: subgrid;
  height: max-content;
`

const MemoizerRow: FC<{
  index: number
  className?: string
  style?: CSSProperties | undefined
  children?: ReactNode
  ref?: React.Ref<HTMLDivElement>
}> = ({ ref, index, className, style, children }) => {
  return (
    <div className={cx('_row', memoizerClass, className)} ref={ref} data-index={index} style={style}>
      {children}
    </div>
  )
}

export const ChangeRootRow: FC<
  ItemGridContentProps<ComparisonDataEntry, ChangeTableContext> & {
    ref?: React.Ref<HTMLDivElement>
  }
> = ({ ref, entry, context, ...props }) => {
  switch (entry.type) {
    case 'group': {
      const anyGroup = entry.base ?? entry.comparison
      if (!anyGroup?.parentGroup) {
        return (
          <MemoizerRow index={props.index} style={props.style} ref={ref} className={props.className}>
            <ChangeGroupRow entry={entry} context={context} />
          </MemoizerRow>
        )
      }
      return (
        <MemoizerRow index={props.index} style={props.style} ref={ref} className={props.className}>
          <ChangeSubGroupRow entry={entry} context={context} />
        </MemoizerRow>
      )
    }
    case 'family': {
      return (
        <MemoizerRow index={props.index} style={props.style} ref={ref} className={props.className}>
          <ChangeFamilyRow entry={entry} context={context} />
        </MemoizerRow>
      )
    }
  }
}
